import * as BP from './Breakpoints';

export const isMobileWidth = () => window.innerWidth <= BP.MQ_SMALL;
